import React from "react";
import { useNavigate } from "react-router-dom";
import TableUser from "./components/TableUser";
import { MdAdd } from "react-icons/md";

function User() {
  const navigate = useNavigate();
  const role = localStorage.getItem("role");

  return (
    <div className="mt-5 px-2">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Manajemen Pengguna</h2>
          <p className="text-sm text-gray-500 mt-1">Kelola akun dan hak akses pengguna</p>
        </div>
        {role === "superadmin" && (
          <button
            onClick={() => navigate("/admin/add-user")}
            className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-white shadow-sm"
            style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
          >
            <MdAdd className="h-5 w-5" />
            Tambah User
          </button>
        )}
      </div>
      <div className="rounded-2xl bg-white shadow-sm overflow-hidden dark:bg-navy-700">
        <TableUser />
      </div>
    </div>
  );
}

export default User;
